export async function copyToClipboard(url: string): Promise<void> {
	await navigator.clipboard.writeText(url);
}

/*
 * `true` -> a share sheet is opened,
 * `false` -> the URL was copied to the clipboard.
 */
export async function shareUrl(data: ShareData): Promise<boolean> {
	if (navigator.share) {
		await navigator.share(data);
		return true;
	}

	if (!data.url) throw new Error('Share URL not set');

	await copyToClipboard(data.url);
	return false;
}
